import { render, staticRenderFns } from "./ProductMenu.vue?vue&type=template&id=2f4fdb4e"
import script from "./ProductMenu.vue?vue&type=script&lang=js"
export * from "./ProductMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports